import React, { useEffect, useState } from "react";
import "./../styles/product.css";
import StarRating from "../components/star-rating/star-rating";
import { BsFillCartCheckFill, BsCartXFill } from "react-icons/bs";
import RankingIcon from "../components/ranking/ranking";
import ToastNotification, {
  showToast,
} from "../components/toasts/ToastNotification";
import { HashLoader } from "react-spinners";
import { getProductBySlug } from "../api/product.api";
import { useNavigate, useParams } from "react-router-dom";
import ProductImageSlider from "../components/product/ProductImageSlider";
import EMPTY_COMMENT from "./../assets/images/empty_comment.png";
import { productAttributesStatusText, userRankText } from "../utils";
import { FaStar } from "react-icons/fa";
import { BsCartPlusFill } from "react-icons/bs";
import { IoIosArrowForward } from "react-icons/io";
import { getSimilarProducts } from "../api/recommend.api";
import { useUser } from "../context/UserContext";
import { addToCart } from "../api/cart.api";

const REVIEW_LIMIT = 6;

const Product = () => {
  const [isViewImage, setIsViewImage] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const [orderPrice, setOrderPrice] = useState(0);
  const [orderDiscount, setOrderDiscount] = useState(0);
  const [orderTotal, setOrderTotal] = useState(0);
  const { user, setCart } = useUser();

  const [recommendations, setRecommendations] = useState(null);

  const [selectedTopUpPackage, setSelectedTopUpPackage] = useState(null);

  const { product_slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetchProductData();
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [product_slug]);

  useEffect(() => {
    const total = orderPrice - orderDiscount;
    setOrderTotal(total);
  }, [orderPrice]);

  useEffect(() => {
    setOrderPrice(selectedTopUpPackage?.price || 0);
  }, [selectedTopUpPackage]);

  const fetchProductData = async () => {
    setLoading(true);

    try {
    const res = await getProductBySlug(product_slug, REVIEW_LIMIT);

    if (res.success) {
      setProduct(res.data.product);
      // console.log(res.data.product);
        if (
          res.data.product.product_type === "game_account" ||
          res.data.product.product_type === "utility_account" ||
          res.data.product.product_type === "gift_card"
        ) {
          setOrderPrice(res.data.product.product_attributes.price);
        } else if (res.data.product.product_type === "topup_package") {
          const availablePackage = res.data.product.product_attributes.packages.find(
            (pkg) => pkg.status === "available"
          );
          setSelectedTopUpPackage(availablePackage || null);
        }

        //trackUserClick(res.data.product.productId);
        document.title = res.data.product.product_name;
        const recommendations = await getSimilarProducts(res.data.product.productId);

        if (recommendations.success) {
          setRecommendations(recommendations.data.recommendations);
          // console.log(recommendations.data.recommendations)
        }
      }
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCheckout = () => {
    const { productId, product_type } = product;

    const queryParams = new URLSearchParams({
      productId,
      product_type: product_type,
    });

    if (product_type === "topup_package") {
      if (!selectedTopUpPackage || selectedTopUpPackage.status !== "available") {
        showToast("Gói nạp này hiện không khả dụng", "error");
        return;
      }
      navigate(`/checkout?${queryParams.toString()}`, {
        state: {
          product_package: {
            ...selectedTopUpPackage,
            product_img: product.product_imgs[0],
          },
        },
      });
    } else {
      navigate(`/checkout?${queryParams.toString()}`, {
        state: {
          product: product,
        },
      });
    }
  };

  const handleAddToCart = async () => {
    if (product?.product_type === "topup_package" && selectedTopUpPackage?.status !== "available") {
      showToast("Gói nạp này hiện không khả dụng", "error");
      return;
    }

    try {
      setLoading(true);

      const res = await addToCart(product?.productId);

      if (res.success) {
        setCart(1);

        showToast("Thêm sản phẩm vào giỏ hàng thành công", "success");
      }

    } catch (error) {
      showToast(error.message, "error");
    }
    finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div style={{ height: "100vh" }} className="loader-container">
        <HashLoader color="#fff" />
      </div>
    );
  }

  return (
    <div className="product-wrapper">
      <div className="product-container">
        <div className="product-left">
          <div className="content">
            {/* Main Product Section */}
            <div className="product">
              <div className="product-gallery">
                <ProductImageSlider images={product?.product_imgs || []} />
              </div>
              <div className="product-info">
                <h1 className="product-title">{product?.product_name}</h1>
                <div className="star-container">
                  <StarRating rating={product?.averageRating} />
                  <p className="sell-amount">
                    Đã bán {product?.product_sold_amount}
                  </p>
                </div>
                {/* <div className="tutorial-button-container">
                  <button className="tutorial-button">Hướng dẫn lấy ID</button>
                  <button className="tutorial-button">Hướng dẫn nạp</button>
                </div> */}
                <div className="product-description-container">
                  <h3 className="product-description-title">Mô tả</h3>
                  <p className="product-description">
                    {product?.product_description.split('\\n').join('\n')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Product Details */}
          {product?.product_type === "topup_package" && (
            <div className="product-topup-package-container">
              <h3 className="product-topup-package-title">Chọn gói nạp</h3>
              <div className="product-item-container">
                {product?.product_attributes?.packages.map((pack) => (
                  <TopUpPackage
                    key={pack._id}
                    selectedTopUpPackage={selectedTopUpPackage}
                    setSelectedTopUpPackage={setSelectedTopUpPackage}
                    pack={pack}
                    product={product}
                  ></TopUpPackage>
                ))}
              </div>
            </div>
          )}

          {/* Payment only display on mobile */}
          <aside
            className={`payment-container ${isMobile ? "enable" : "disable"}`}
          >
            <h2 className="payment-title">Đơn hàng</h2>
            <div className="item-container">

            </div>
            <div className="price-container">
              <p className="price-text">Giá tiền</p>
              <p className="price-text">{orderPrice.toLocaleString() || 0}đ</p>
            </div>
            <div className="price-container">
              <p className="price-text">Giảm giá</p>
              <p className="price-text">{orderDiscount.toLocaleString() || 0}đ</p>
            </div>
            <div className="total-price-container">
              <p className="total-label">Tổng</p>
              <p className="total-amount">{orderTotal.toLocaleString() || 0}đ</p>
            </div>
            <div className="checkout-button-container">
              <button onClick={handleAddToCart} className="add-to-cart-button">Thêm vào giỏ hàng</button>
              <button onClick={handleCheckout} className="checkout-button">
                Thanh toán ngay
              </button>
            </div>
          </aside>

          {/* Customer Reviews */}
          <div className="reviews">
            <div className="review-header-container">
              <div className="review-title-rating-container">
                <h2 className="reviews-title">Đánh giá từ khách hàng</h2>
                <div className="rating-container">
                  <p className="rating-value">{product?.averageRating.toFixed(1) || 0}</p>
                  <FaStar className="rating-icon" />
                </div>
              </div>
              <div onClick={() => navigate(`/product/reviews/${product_slug}`)} className="view-all-reviews-container">
                <a className="view-all-reviews-text">Xem tất cả</a>
                <IoIosArrowForward />
              </div>
            </div>
            {Array.isArray(product?.reviews) && product?.reviews.length > 0 ? (
              <div className="review-item-container">
                {product?.reviews.map((review) => (
                  <ReviewItem key={review?._id} review={review} />
                ))}
              </div>
            ) : (
              <div className="empty-comment-container">
                <img
                  className="empty-comment-img"
                  src={EMPTY_COMMENT}
                  alt="Empty comment"
                ></img>
                <p className="empty-comment-title">Chưa có đánh giá</p>
              </div>
            )}
          </div>
        </div>

        <div className="product-right">
          {/* Aside Payment Section */}
          <aside
            className={`payment-container ${isMobile ? "disable" : "enable"}`}
          >
            <h2 className="payment-title">Đơn hàng</h2>
            <div className="item-container">
            </div>
            <div className="price-container">
              <p className="price-text">Giá tiền</p>
              <p className="price-text">{orderPrice?.toLocaleString() || 0}đ</p>
            </div>
            <div className="price-container">
              <p className="price-text">Giảm giá</p>
              <p className="price-text">
                {orderDiscount?.toLocaleString() || 0}đ
              </p>
            </div>
            <div className="total-price-container">
              <p className="total-label">Tổng</p>
              <p className="total-amount">{orderTotal?.toLocaleString() || 0}đ</p>
            </div>

            <div className="checkout-button-container">
              <button onClick={handleAddToCart} className="add-to-cart-button">Thêm vào giỏ hàng</button>
              <button onClick={handleCheckout} className="checkout-button">
                Thanh toán ngay
              </button>
            </div>
          </aside>
          <div className="recommend-products-container">
            <h3>Sản phẩm gợi ý</h3>
            <div className="recommend-card-container">
              {recommendations?.length > 0 &&
                recommendations?.map((rec) => (
                  <RecommendProductCard key={rec?.product_name} onClick={() => navigate(`/product/${rec?.product_slug}`)} rec={rec} />
                ))
              }
            </div>
          </div>
        </div>

        {isViewImage && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0, 0, 0, 0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
            onClick={() => setIsViewImage(false)}
          >
            <img
              src="https://fontmeme.com/images/clash-royale-GAME-FONT.jpg"
              alt="Full View"
              style={{ maxWidth: "90%", maxHeight: "90vh" }}
            />
          </div>
        )}
        <ToastNotification />
      </div>
    </div>
  );
};

const RecommendProductCard = ({ rec, onClick }) => {
  return (
    <div onClick={onClick} className="recommend-card">
      <img src={rec?.product_img || null} className="recommend-card-img" alt="Recommend Product"></img>
      <div className="product-details-container">
        <p className="product-details-name">{rec?.product_name || "Product"}</p>
        <p className="product-details-price">{(rec?.product_price?.toLocaleString() || Math.min(...rec?.packages?.map((p) => p.price))?.toLocaleString()) || 0}đ</p>
        <p className="product-details-sold-amount">Đã bán {rec?.product_sold_amount || 0}</p>
      </div>
    </div>
  )
}

const ReviewItem = ({ review }) => {
  return (
    <div className="review-item">
      <img
        className="review-item-user-avatar"
        src={review?.userId?.profileImg || "https://i.pravatar.cc/300"}
        alt="user-avatar"
      ></img>
      <div className="review-item-user-info-container">
        <div className="review-item-username-rating">
          <p className="review-item-username">{review?.userId?.username || "Người dùng"}</p>
          <StarRating rating={review?.rating || 0} />
        </div>
        <div className="review-item-ranking-container">
          <RankingIcon rank={review?.userId?.rank || "diamond"} />
          <p className="user-rank-text">{userRankText(review?.userId?.rank) || ""}</p>
        </div>
        <div className="review-item-user-comment-container">
          <p className="user-comment">{review?.comment}</p>
          <p className="comment-date">{new Date(review?.createdAt).toLocaleDateString() || ""}</p>
        </div>
      </div>
    </div>
  );
};

const TopUpPackage = ({
  selectedTopUpPackage,
  setSelectedTopUpPackage,
  pack,
  product
}) => {
  const isAvailable = pack?.status === "available";

  const handleSelect = () => {
    if (!isAvailable) return;
    setSelectedTopUpPackage(pack);
  };

  return (
    <div
      className={`product-item ${selectedTopUpPackage?._id === pack?._id && "active-package"
        } ${!isAvailable ? "disabled-package" : ""}`}
      onClick={handleSelect}
    >
      <img
        className="product-item-img"
        alt="Top Up Package"
        src={pack?.img || "https://img.redbull.com/images/c_fill,g_auto,w_450,h_600/q_auto:low,f_auto/redbullcom/2016/05/10/1331793850853_2/clash-royale-trucchi-e-consigli-1"}
      ></img>
      <div className="product-item-info">
        <p className="product-item-name">{pack?.name}</p>
        <div className="product-item-order-type-container">
          <div className="product-item-order-type">
            {pack?.status === "available" ? (
              <BsFillCartCheckFill className="product-item-order-icon" />
            ) : (
              <BsCartPlusFill className="product-item-order-icon" />
            )}
            <p
              className={`product-item-order-value ${pack?.status === "available" ? "" : ""
                }`}
            >
              {productAttributesStatusText(pack?.status)}
            </p>
          </div>
          <div className="product-item-price-discount-container">
            {/* <p className="product-item-discount">20.000VND</p> */}
            <p className="product-item-price">
              {pack?.price.toLocaleString()}đ
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
